import { toast, useApiClient } from '@startupquickstart/frontend';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface UpdateTemplatePinInput {
  /** The TemplateChallengeLink id. */
  linkId: string;
  latitude: number;
  longitude: number;
}

/**
 * Persists a template challenge pin move by setting the per-template coordinate
 * override on its `TemplateChallengeLink` (PATCH /templates/:id/challenges/:linkId).
 * This does NOT touch the underlying library challenge — see
 * docs/CHALLENGE_LOCATION_HIERARCHY.md.
 */
export function useUpdateTemplatePin(templateId: string) {
  const apiClient = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ linkId, latitude, longitude }: UpdateTemplatePinInput) =>
      apiClient.patch(`/templates/${templateId}/challenges/${linkId}`, { latitude, longitude }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['TemplateChallenges', templateId] });
      void queryClient.invalidateQueries({ queryKey: ['TemplateGroups', templateId] });
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to update location');
    },
  });
}
